import { ObjectInitiationController } from './object-initiation-screen.controller';
import { ObjectInitiationProps } from './object-initiation-screen.model';

const ObjectInitiationScreen = (props: ObjectInitiationProps) => {
  return <ObjectInitiationController {...props} />;
};

export default ObjectInitiationScreen;
